import React, {useContext} from 'react';
import { Navigate } from "react-router-dom";
import AuthContext from '../AuthContext';
import jwt_decode from "jwt-decode";

// partner-multiplatform has the exact same permissions as partner (mirrors the
// same alias applied server-side in verifyAccessMiddleware.js) -- expanding it
// here means every existing/future <ProtectedRoute roles={[...,'partner',...]}>
// covers it automatically instead of editing every route in App.tsx.
const expandRoles = (roles: string[]): string[] =>
    roles.includes('partner') ? [...roles, 'partner-multiplatform'] : roles

const ProtectedRoute = ({ children, roles }: any) => {
    const { token }   = useContext(AuthContext) as any;
    const tokenDecode = (token!==null) ? jwt_decode(token) : null as any
    const expandedRoles = expandRoles(roles);
    // const [tokenDecode, setTokenDecode] = useState(token!==null ? jwt_decode(token) : null)
    // if (!token) {
    if (token===null){
        // user is not authenticated
        return <Navigate to="/dashboard" />;
    }else{
        const x = tokenDecode?.roles.find((x: any) => expandedRoles.includes(x.name) );
        if( x === undefined) {
            // user is not authenticated
            return <Navigate to="/dashboard" />;
        }
    }
    return children;
}

export default ProtectedRoute